import { Injectable } from '@angular/core';
import { StockTransferLine } from './stockTransferLine';

@Injectable({
providedIn:'root'
})

export class StockTransferHeader {
public activeProduct?:string;
public accountOwnerName?:string;
public  accountOwnerId?: number;
public productId?: string;
public  sourceWarehouseId?: number;
public  accountOwnerContactId?: number;
public accountOwnerCustomerId?:number;
public  destWarehouseId?: number;
public  destWarehouseName?: string;
public  sourceWarehouseName?: string;
public  contactName?: string;
public  name?: string;
public  orderType?: string;
public  destinationWarehouseName?: string;
public stockEntryNumber?: number;
public  destWarehouseAddressText?: string;
public  sourceWarehouseAddress?: string;
public  warehouseAddressText?: string;
public  destinationWarehouseAddress?: string;
public  warehouseName?: string;
public  orderStatus?: string;
public  organizationId?: number;
public  warehouseId?: number;
public stockTransferHeaderId?: number;
public shippingMethod?: string;
public productConfig?: string;
public addressText?: string;
public shippingOption?: string;
public deliveryInstructions?: string;
public id?: number;
public  stockLinesList?: StockTransferLine[];
public  shipLines?: StockTransferLine[];
public  lines?: StockTransferLine[];
public orderNumber?: number;
public orderedDate?: string;
public accountOwnerCustomerName?: string;
// public orderNumber ?: string;
public shipMethod ?: string;
public additionalInfo ?: string;
public connectionName ?: string;
public providerStatus ?: string;
public sourceOrderDate ?: string;
public trackingNumber ?: string;
public awbNumber ?: string;
public sourceOrderId ?: number;
public createdDate ?: string;
public sourceWarehouseAddressText ?: string;
public ownerAddressText ?: string;
}
